export default (modalStr, condition) => {
  if (condition) {
    return;
  }

  const bodyElement = document.body;
  const modal = convertStr2Dom(modalStr);

  bodyElement.appendChild(modal);
  bodyElement.initModal();
}

const convertStr2Dom = (str) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = str;
  return wrapper.firstElementChild;
}
